import { Component, HostListener, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_MultiStationViewVisitors } from "../../shared/data.service";
import { VisitorAliasLookupRequest } from "../../shared/VisitorAliasLookupRequest";
import { VisitorAliasRequest } from "../../shared/VisitorAliasRequest";

@Component({
	selector: "app-ms-add-alias",
	templateUrl: "./ms-add-alias.component.html",
	styleUrls: ["./ms-add-alias.component.css"],
})
export class MsAddAliasComponent implements OnInit {
	constructor(
		private visitorService: DataService_MultiStationViewVisitors,
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		this.PersonID = this.dialogConfig.data.PersonID;
		this.FirstName = this.dialogConfig.data.FirstName;
		this.LastName = this.dialogConfig.data.LastName;
		this.LicenseNbr = this.dialogConfig.data.LicenseNbr;

		this.loadVisitorType();
		this.loadVisitorStatus();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////
	PersonID: number;
	FirstName: string = "";
	LastName: string = "";
	LicenseNbr: string = "";

	LoadingVisitorType: boolean = false;
	VisitorTypeID: number;
	lstVisitorType: any = [];

	LoadingVisitorStatus: boolean = false;
	VisitorStatusID: number;
	lstVisitorStatus: any = [];

	Filter: string = "";

	LoadingTable: boolean = false;
	lstPerson: any = [];
	SelectedPersons: any = [];

	pagerows: any = 5;
	pagefirst: any = 0;

	lstState: any = [];
	lstVisitorTypeDesc: any = [];
	lstVisitorStatusDesc: any = [];

	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "FirstName", header: "First Name" },
		{ field: "LastName", header: "Last Name" },
		{ field: "LicenseNbr", header: "License" },
		{ field: "State", header: "State" },
		{ field: "Email", header: "Email" },
		{ field: "PhoneNbr", header: "Phone" },
		{ field: "VisitorTypeDesc", header: "Type" },
		// { field: 'VisitorStatusDesc', header: 'Status' },
	];

	errorMessage: any = "";
	Processing: boolean = false;

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadVisitorType() {
		this.LoadingVisitorType = true;

		var result = this.visitorService.VisitorTypeSelectList();
		result.subscribe(
			(response) => {
				this.lstVisitorType = response;

				this.lstVisitorType.unshift({
					VisitorTypeID: -1,
					VisitorTypeDesc: "Any",
				});

				this.VisitorTypeID = this.lstVisitorType[0].VisitorTypeID;

				this.LoadingVisitorType = false;
			},
			(error) => {
				this.LoadingVisitorType = false;
			}
		);
	}

	loadVisitorStatus() {
		this.LoadingVisitorStatus = true;

		var result = this.visitorService.VisitorStatusSelectList();
		result.subscribe(
			(response) => {
				this.lstVisitorStatus = response;

				this.lstVisitorStatus.unshift({
					VisitorStatusID: -1,
					VisitorStatusDesc: "Any",
				});

				this.VisitorStatusID = this.lstVisitorStatus[0].VisitorStatusID;

				this.LoadingVisitorStatus = false;
			},
			(error) => {
				this.LoadingVisitorStatus = false;
			}
		);
	}

	loadData() {
		this.errorMessage = "";
		this.SelectedPersons = [];

		this.LoadingTable = true;

		var parms: VisitorAliasLookupRequest = {
			PersonID: this.PersonID,
			VisitorTypeID: this.VisitorTypeID,
			VisitorStatusID: this.VisitorStatusID,
			Filter: this.Filter,
		};

		var result = this.visitorService.VisitorAliasLookup(parms);
		result.subscribe(
			(response) => {
				this.lstPerson = response;

				this.lstState = Array.from(new Set(this.lstPerson.map((item: any) => item.State))).sort();
				this.lstVisitorTypeDesc = Array.from(new Set(this.lstPerson.map((item: any) => item.VisitorTypeDesc))).sort();
				this.lstVisitorStatusDesc = Array.from(new Set(this.lstPerson.map((item: any) => item.VisitorStatusDesc))).sort();

				this.LoadingTable = false;
			},
			(error) => {
				this.LoadingTable = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onSearch() {
		this.loadData();
	}

	onAdd() {
		this.errorMessage = "";

		if (this.SelectedPersons.length == 0) {
			this.errorMessage = "Select Visitors that are the same person as the select one";
			return;
		}

		this.Processing = true;

		var lstPIDs: number[] = [];

		for (var z = 0; z < this.SelectedPersons.length; z++) {
			var next = this.SelectedPersons[z];

			lstPIDs = [...lstPIDs, next.PersonID];
		}

		var parms: VisitorAliasRequest = {
			PersonID: this.PersonID,
			lstAlias: lstPIDs,
		};

		var result = this.visitorService.VisitorAliasInsert(parms);
		result.subscribe(
			(response: any) => {
				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "addalias",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Visitors were added as aliases for reporting.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "addalias",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not add visitors as aliases: " + response,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}

				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////

	onRowSelect(val) {
		this.errorMessage = "";
	}
	onRowUnselect(val) {
		this.errorMessage = "";
	}

	IsLoading() {
		return this.LoadingVisitorType == true || this.LoadingVisitorStatus == true || this.LoadingTable == true || this.Processing == true;
	}

	@HostListener("window:keydown", ["$event"])
	LogKeys(event: KeyboardEvent) {
		if (event.key == "Enter") {
			this.onSearch();
		}
	}

	////////////////////////////////////////////
}
